<form #formControl="ngForm">
  <mat-dialog-content>
    <div class="form">
      <mat-form-field appearance="outline" color="accent" class="full-width">
        <mat-label>Binding Name</mat-label>
        <input matInput #input [(ngModel)]="bindingName" name="bindingName" placeholder="Enter binding name" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Target Field</mat-label>
        <mat-select [(ngModel)]="targetField" (ngModelChange)="onTargetFieldSelection($event)" name="selectedTargetField" placeholder="Select target field" required>
          @for (item of fieldList; track item.id ?? item.name) {
          <mat-option [value]="item">
            {{ item['name'] }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Shape</mat-label>
        <mat-select [(ngModel)]="selectedShape" name="selectedShape" placeholder="Select shape" required>
          @for (item of shapeList; track item) {
          <mat-option [value]="item">
            {{ item }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="color-picker-container">
        <label class="color-label">Default Color</label>
        <input [(colorPicker)]="defaultColor" [style.background]="defaultColor" name="defaultColor" class="color-input" (colorPickerChange)="defaultColor = $event" />
      </div>

      @if (targetField?.['fieldType'] === 'DropdownSingle') {
      <div class="color-options-container">
        <h4 class="section-title">Color Options</h4>
        @for (val of targetField['value']['options']; track val; let i = $index) {
        <div class="color-option-row">
          <input [(colorPicker)]="color" [style.background]="colorData[i]['color']" name="nodecolor_{{ i }}" class="color-input" (colorPickerChange)="colorData[i]['color'] = $event" />
          <span class="option-label">{{ val }}</span>
        </div>
        }
      </div>
      } @if (targetField?.['fieldType'] === 'Checkbox') {
      <div class="color-options-container">
        <h4 class="section-title">Checkbox Colors</h4>
        <div class="color-option-row">
          <input [(colorPicker)]="color" [style.background]="colorData[0]['color']" name="nodecolor_checked" class="color-input" (colorPickerChange)="colorData[0]['color'] = $event" />
          <span class="option-label">{{ colorData[0]['value'] }}</span>
        </div>
        <div class="color-option-row">
          <input [(colorPicker)]="color" [style.background]="colorData[1]['color']" name="nodecolor_unchecked" class="color-input" (colorPickerChange)="colorData[1]['color'] = $event" />
          <span class="option-label">{{ colorData[1]['value'] }}</span>
        </div>
      </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!formControl.valid" [mat-dialog-close]="1" (click)="confirmAdd()">Save</button>
  </mat-dialog-actions>
</form>
